import React, { useEffect } from "react";

import { Input, InputLabel } from "component";
import EntryScreensForm from "./EntryScreensForm";

import OtpVerify from "react-native-otp-verify";
import { useForm, Controller } from "react-hook-form";

import { patterns, strings } from "asset/constant";

import { useInsertMobile } from "client/api";
import { Platform } from "react-native";
import { useSetRecoilState } from "recoil";
import { routeParamsAtom } from "store";

export default function InsertMobile() {
  const insertMobileMut = useInsertMobile();

  const setRouteParams = useSetRecoilState(routeParamsAtom);

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      mobile: "",
      hash_code: "",
    },
  });

  const _confirm = () => insertMobileMut.mutate(getValues());
  const _submit = handleSubmit(_confirm);

  useEffect(() => {
    if (Platform.OS === "android") {
      OtpVerify.getHash().then((res) => {
        setValue("hash_code", res[0]);
        setRouteParams((prev) => ({ ...prev, hash_code: res[0] }));
      });
    }
  }, [setValue]);

  return (
    <EntryScreensForm
      hideBackButton
      submit={_submit}
      submitLabel={strings.login}
      submitLoading={insertMobileMut?.isLoading}
    >
      <InputLabel label={strings.mobile} />
      <Controller
        control={control}
        name="mobile"
        rules={{
          required: { value: true, message: strings.mobile_is_required },
          pattern: { value: patterns.mobile, message: strings.invalid_mobile },
        }}
        render={({ field }) => (
          <Input
            value={field.value}
            onChangeText={(input) => {
              field.onChange(input);
              setRouteParams((prev) => ({ ...prev, mobile: input }));
            }}
            placeholder={strings.insert_mobile}
            icon={{ name: "user" }}
            onSubmitEditing={_submit}
            keyboardType="phone-pad"
            error={errors.mobile?.message}
            maxLength={11}
          />
        )}
      />
    </EntryScreensForm>
  );
}
